import { combineReducers } from 'redux';

import genericErrorReducer from 'modules/global/reducers/generic.error';
import * as types from 'modules/statistics/actionTypes';

import data from './data';
import isFetching from './isFetching';

/**
 * @typedef {{
 *  apiError: string,
 *  data: import('./data').State,
 *  isFetching: import('./isFetching').State,
 * }} StatisticsSelfServiceDetailsReducer
 */

export default combineReducers({
  data,
  isFetching,
  apiError: genericErrorReducer(types.FETCH_DETAILS_SELF_SERVICE_STATS),
});
